import { render } from "./ImageRightTextHigh.vue?vue&type=template&id=646e69e9&scoped=true"
import script from "./ImageRightTextHigh.vue?vue&type=script&lang=js"
export * from "./ImageRightTextHigh.vue?vue&type=script&lang=js"

import "./ImageRightTextHigh.vue?vue&type=style&index=0&id=646e69e9&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646e69e9"]])

export default __exports__